import React, { useState, useEffect } from 'react';
import { AlphaAddition } from '@pixelogicmedia/phelix_coredb_frontend';
import { Modal } from 'antd';
import { getEnv, interceptor, creationSource } from "../../helpers/utils";

const EditAlpha = ({ alphaId, titleId }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const showModal = () => setVisible(true);
        const button = document.getElementById('edit-alpha-btn');
        button.addEventListener('click', showModal);

        return () => {
            button.removeEventListener('click', showModal);
        };
    }, []);

    const onAlphaUpdated = () => {
        setVisible(false);
        window.location.reload();
    };

    const handleCancel = () => {
        setVisible(false);
    };

    return (
        <Modal 
            visible={visible}
            title="Edit Alpha"
            onCancel={handleCancel}
            width={700}
            footer={null}
            destroyOnClose={true}
        >
            <AlphaAddition 
                id={alphaId}
                creationSource={creationSource}
                titleId={titleId}
                alphaSaved={onAlphaUpdated}
                axiosInstance={interceptor()}
                modalLayout={true}
                env={getEnv()}
            />
        </Modal>
    );
};

export default EditAlpha;